import { Hospital } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from '../../brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../../brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../../brokers/types'
import { useGetInsuranceCarriers } from '../../hooks/needs_attention/useGetInsuranceCarriers'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'

const CarrierNameFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data: carriers } = useGetInsuranceCarriers()

  const carrierOptions: ComboboxFilterOption<string>[] | undefined =
    carriers?.map((carrier) => ({
      label: carrier.carrier_name,
      value: carrier.carrier_name,
    }))

  const filteredOptions = carrierOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Carrier names', options: filteredOptions || [] },
        ]}
        placeholder='Search carriers to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={carrierOptions || []}
          noSelectionText='Ancestor Carrier Name'
          pluralIdentifier='carriers'
        >
          <Hospital size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default CarrierNameFilter
